import {
  Collection,
  CollectionType,
  Value
} from '@features/product/components/Collection/Collection.types';

export const shouldShowCollection = (collection: Collection) => {
  const { discriminants, type } = collection;
  let shouldShow = true;

  const currentProductIsInAllDiscriminants =
    discriminants.filter(discriminant => {
      return discriminant.values.find(value => value.isValueOfCurrentProduct) !== undefined;
    }).length === discriminants.length;

  if (!currentProductIsInAllDiscriminants) {
    return false;
  }

  // Check if all values have shouldShowValue set to false, if so, filter it out
  const discriminantsWithShowValue = discriminants.filter(
    discriminant => !discriminant.values.every(value => !value.shouldShowValue)
  );

  if (discriminantsWithShowValue.length === 0) {
    shouldShow = false;
  }

  if (type === CollectionType.PROPERTY) {
    shouldShow =
      discriminants.filter(
        discriminant => discriminant.values.filter(value => value.shouldShowValue).length > 1
      ).length > 0;
  }

  if (type === CollectionType.DROPDOWN) {
    let validDiscriminants = 0;

    discriminants.forEach(discriminant => {
      if (discriminantValuesWithProducts(discriminant.values).length > 1) {
        validDiscriminants++;
      }
    });

    if (validDiscriminants === 0) {
      shouldShow = false;
    }
  }

  return shouldShow;
};

export function discriminantValuesWithProducts(values: Value[]) {
  return values.filter(value => value.products.length > 0 && value.shouldShowValue);
}
